"use client";

import { Badge } from "@/components/ui/badge";
import { Mail, MapPin, Phone } from "lucide-react";
import { motion } from "motion/react";
import { GridSvg } from "@/components/gridSvg";

export default function GetInTouch() {
  return (
    <section className="wrapper relative py-[75px]">
      <GridSvg />
      <motion.div
        initial={{ opacity: 0, y: 150 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.5 }}
        className={"flex flex-col gap-5 items-center text-center"}
      >
        <Badge>Get In Touch</Badge>
        <h1 className={"text-4xl font-bold"}>
          Ready to Innovate with{" "}
          <span className={"text-primary"}>Technology?</span>
        </h1>
        <p
          className={
            "text-muted-foreground font-semibold text-lg font-semibold"
          }
        >
          Connect with us today to discover how we can bring cutting-edge
          solutions to your business.
        </p>

        <div className={"grid grid-cols-1 w-full  md:grid-cols-3 gap-5 mt-5"}>
          <div className="square-gradient-bg   text-background bg-background h-full transition-all duration-500 hover:shadow-2xl hover:shadow-emerald-500/10">
            <div className="p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-r bg-primary rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <Phone className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-4 text-foreground">
                Phone
              </h3>
              <div className="space-y-2 text-muted-foreground font-semibold">
                <p>+975 - 17112040</p>
                <p>+975 - 77353525</p>
              </div>
            </div>
          </div>

          <div className="square-gradient-bg   text-background bg-background h-full transition-all duration-500 hover:shadow-2xl hover:shadow-emerald-500/10">
            <div className="p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-r bg-primary rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <Mail className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-4 text-foreground">
                Email
              </h3>
              <p className="text-muted-foreground font-semibold">
                tradingvisiontech@gmail.com
              </p>
            </div>
          </div>

          <div className="square-gradient-bg   text-background bg-background h-full transition-all duration-500 hover:shadow-2xl hover:shadow-emerald-500/10">
            <div className="p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-r bg-primary rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <MapPin className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-4 text-foreground">
                Address
              </h3>
              <div className="text-muted-foreground font-semibold space-y-1">
                <p>VisionTech Trading</p>
                <p>PO Box 501, Motithang</p>
                <p>Thimphu 11001, Bhutan</p>
              </div>
            </div>
          </div>
        </div>
        <div className={"w-full md:w-fit"}>
          <div className="inline-block w-full md:w-fit bg-muted">
            <div className="p-6">
              <p className="text-muted-foreground font-semibold">
                <span className="font-medium">TPN No:</span> VAB020811 |{" "}
                <span className="font-medium">License No:</span> R1013229
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
